<template>
  <Layout>
    <template #header>
      <!-- <span class="text-h6">dTCS</span> -->
      <!-- :disable="!!notifyData.UIRx_VehSpd && notifyData.UIRx_VehSpd > 1" -->

      <!-- <span class="text-h6">TCS</span> -->
      <!-- <div class="q-ml-lg text-subtitle1">请在车辆静止时切换</div> -->

      分布式牵引力控制
      <!-- <span class="text-h6">dTCS</span> -->
      <!-- :disable="!!notifyData.UIRx_VehSpd && notifyData.UIRx_VehSpd > 1" -->

      <!-- <span class="text-h6">TCS</span> -->
      <!-- <div class="q-ml-lg text-subtitle1">请在车辆静止时切换</div> -->
    </template>
    <!-- <div class="glowing-effect"></div> -->
    <div class="row q-col-gutter-x-md full-height">
      <div class="col-5 column justify-around">
        <q-card bordered class="full-height column">
          <q-card-section class="row">
            <ToggleSwitch
              :model-value="switching"
              @update:model-value="handleSwitchChange"
              color="#4caf50"
              true-value="dTCS"
              false-value="TCS"
            >
            </ToggleSwitch>
          </q-card-section>
          <q-card-section class="row" style="flex: 1">
            <!-- car   -->
            <div
              class="row justify-around items-center car-img relative-position"
              style="flex: 1"
            >
              <q-img
                :src="底盘透明_纵向_带轮胎"
                :style="{
                  height: IMG_HEIGHT + 'px',
                  width: IMG_WIDTH + 'px',
                }"
                spinner-color="white"
                fit="contain"
              >
                <div
                  class="fit column justify-center items-center"
                  :style="{
                    'padding-top': PADDING_TOP + 'px',
                    'padding-bottom': PADDING_BOTTOM + 'px',
                  }"
                >
                  <div
                    v-for="arrowGroup in arrowConfigs"
                    :key="arrowGroup.class"
                    :class="arrowGroup.class"
                  >
                    <ArrowGauge
                      v-for="item in arrowGroup.items"
                      :type="item.class"
                      :key="item.class"
                      :class="item.class"
                      :value="item.value as number"
                      :max="item.class === 'arrow-top' ? 4000 : 2000"
                      :color="
                        item.class === 'arrow-top' ? '#2196f3' : '#ff5722'
                      "
                    />
                  </div>
                  <BlockProgressTip
                    direction="front"
                    :status="DMCFrStatus"
                    :switching="switching"
                  />
                  <LinearProgressTip
                    direction="front"
                    :status="FrontAxleDecTorqReq_Status"
                    :leftStatus="DMCFrStatus"
                    :switching="switching"
                  />
                  <div
                    class="bg-blue row justify-center items-center text-white"
                    style="border-radius: 10px; height: 50px; width: 150px"
                  >
                    TCS
                  </div>

                  <LinearProgressTip
                    reverse
                    direction="back"
                    :status="RearAxleDecTorqReq_Status"
                    :leftStatus="DMCRrStatus"
                    :switching="switching"
                  />
                  <BlockProgressTip
                    direction="back"
                    :status="DMCRrStatus"
                    :switching="switching"
                  />
                </div>
              </q-img>
            </div>
            <div
              key="1"
              :class="`absolute-center`"
              :style="{
                position: 'absolute',
                left: 60 + 'px',
              }"
            >
              <Statistic
                name="车辆行驶速度"
                :value="(notifyData.UIRx_VehSpd || 0).toFixed(1)"
                units-of-measurement="kph"
                icon=""
                :width="150"
                style="font-size: 14px"
              ></Statistic>
            </div>
            <div
              key="2"
              :class="`absolute-center`"
              :style="{
                position: 'absolute',
                right: -35 + 'px',
                left: 'unset',
              }"
            >
              <Statistic
                key="2"
                name="车辆加速度"
                :value="(notifyData.UIRx_ACULongdAcc || 0).toFixed(2)"
                units-of-measurement="g"
                icon=""
                :width="120"
                style="font-size: 14px"
              ></Statistic>
            </div>
          </q-card-section>
          <!-- <q-card-section class="row justify-end q-pt-none"> 
                <Statistic
                  key="1"
                  name="车辆行驶速度"
                  :value="notifyData.UIRx_VehSpd"
                  units-of-measurement="kph"
                  icon=" "
                ></Statistic>
                <Statistic
                  key="2"
                  name="车辆加速度"
                  :value="notifyData.UIRx_ACULongdAcc"
                  units-of-measurement="g"
                  icon=""
                ></Statistic> 
              </q-card-section> -->

          <PlayPauseButton
            :style="{
              position: 'absolute',
              right: '23px',
              bottom: '23px',
            }"
            :initial-state="playStatus === 'play'"
            @toggle="handlePlayStatusChange"
          />
          <!-- <q-btn
            :style="{
              position: 'absolute',
              right: '23px',
              bottom: '23px',
            }"
            :class="playStatus === 'play' ? 'btn-active' : 'btn-style'"
            @click="handlePlayStatusChange"
            size="16px"
            round
            :color="playStatus === 'play' ? 'grey-9' : 'brown-4'"
            text-color="grey-1"
            :icon="playStatus === 'play' ? 'pause' : 'play_arrow'"
          /> -->
        </q-card>
      </div>
      <div class="col-7 column q-col-gutter-y-md">
        <div style="flex: 1" key="2">
          <q-card bordered class="column full-height">
            <q-card-section class="q-pb-none row">
              <div class="text-h6">dTCS控制</div>
              <q-btn
                style="
                  z-index: 2;
                  left: 10px;
                  top: 0px;
                  width: 50px;
                  font-size: 12px;
                  border-radius: 5px;
                "
                color="blue-grey-13"
                :icon="'img:' + 切换"
                @click="slide2 = slide2 === 1 ? 2 : 1"
              />
            </q-card-section>

            <q-card-section
              class="overflow-hidden q-pa-none relative-position"
              style="flex: 1"
            >
              <DomainControlCharts
                ref="chartRefF2"
                class="absolute"
                :style="{
                  top: '0px',
                  transform:
                    slide2 === 1 ? 'translateX(0px)' : 'translateX(5000px)',
                }"
                :max="80"
                :min="0"
                :x-axis-length="10"
                :series="optionsF2"
                :data-zomm-mirror-drag="false"
                @data-zoom="handleDataZoom"
              />
              <DomainControlCharts
                ref="chartRefR2"
                class="absolute"
                :style="{
                  top: '0px',
                  transform:
                    slide2 === 2 ? 'translateX(0px)' : 'translateX(5000px)',
                }"
                :max="80"
                :min="0"
                :x-axis-length="10"
                :series="optionsR2"
                :data-zomm-mirror-drag="false"
                @data-zoom="handleDataZoom"
              />
              <!-- <div class="full-height column overflow-hidden">
                <div class="col-6 overflow-hidden" style="flex: 1">
                  <Charts :options="optionsF2" ref="chartF2" />
                </div>
                <div class="col-6 overflow-hidden" style="flex: 1">
                  <Charts :options="optionsR2" />
                </div>
              </div> -->
            </q-card-section>
          </q-card>
        </div>
        <div style="flex: 1" key="1">
          <q-card bordered class="column full-height">
            <q-card-section class="q-pb-none row">
              <div class="text-h6">TCS控制</div>
              <!-- <q-btn
                style="margin-left: 10px"
                color="secondary"
                :icon="'swap_horiz'"
                @click="slide = slide === 1 ? 2 : 1"
              /> -->
            </q-card-section>

            <q-card-section
              class="overflow-hidden q-pa-none relative-position"
              style="flex: 1"
            >
              <!-- <Charts :options="optionsF" /> -->
              <DomainControlCharts
                ref="chartRefF"
                class="absolute"
                :style="{
                  top: '0px',
                  transform:
                    slide2 === 1 ? 'translateX(0px)' : 'translateX(5000px)',
                }"
                :max="80"
                :min="0"
                :x-axis-length="10"
                :series="optionsF"
                :data-zomm-mirror-drag="false"
                @data-zoom="handleDataZoom"
              />
              <DomainControlCharts
                ref="chartRefR"
                class="absolute"
                :style="{
                  top: '0px',
                  transform:
                    slide2 === 2 ? 'translateX(0px)' : 'translateX(5000px)',
                }"
                :max="80"
                :min="0"
                :x-axis-length="10"
                :series="optionsR"
                :data-zomm-mirror-drag="false"
                @data-zoom="handleDataZoom"
              />
              <!-- <div class="full-height column overflow-hidden">
                <div class="col-6 overflow-hidden" style="flex: 1">
                  <Charts :options="optionsF" ref="chartF2" />
                </div>
                <div class="col-6 overflow-hidden" style="flex: 1">
                  <Charts :options="optionsR" />
                </div>
              </div> -->
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import { computed, reactive, ref, watch } from "vue";
import {
  decreasingSequence,
  FunctionStatus,
  getDefaultSeriesData,
  optionseries1,
  optionseries2,
  parseMotTq,
  parseNegative,
  PlayStatus,
} from "./helper/dmc";
import Layout from "./components/Layout.vue";
import useInitialize from "@/composables/domainControl/useInitialize";
import { SERVICE } from "@/services/domainControl/define";
import { NOTIFY } from "@/services/domainControl/dmc";
import { useQuasar } from "quasar";
import { useDomainControlStore } from "@/stores/domainControl";
import ArrowGauge from "@/components/ArrowGauge.vue";
import LinearProgressTip from "./components/DMC/LinearProgressTip.vue";
import BlockProgressTip from "./components/DMC/BlockProgressTip.vue";
import { toFixed } from "@/utils/math";
import DomainControlCharts from "@/components/DomainControlCharts";
import 切换 from "@/assets/img/切换.png";
import 底盘透明_纵向_带轮胎 from "@/assets/img/底盘透明_纵向_带轮胎.png";
// import Statistic from "@/components/Statistic";
import Statistic from "@/views/DomainControl/components/IVSE/Statistic";
import ToggleSwitch from "@/components/ToggleSwitch";
import PlayPauseButton from "@/components/PlayPauseButton.vue";

const $q = useQuasar();
const domainControlStore = useDomainControlStore();

const IMG_HEIGHT = 550;
const CAR_HEIGHT = 1262;
const IMG_RATE = IMG_HEIGHT / CAR_HEIGHT;
const IMG_WIDTH = 567 * IMG_RATE;
const PADDING_TOP = 190 * IMG_RATE;
const PADDING_BOTTOM = 240 * IMG_RATE;

const seriesData = ref(getDefaultSeriesData());
const optionsF = ref(optionseries1());
const optionsR = ref(optionseries2());
const optionsF2 = ref(optionseries1());
const optionsR2 = ref(optionseries2());
const chartRefF = ref<InstanceType<typeof DomainControlCharts>>();
const chartRefR = ref<InstanceType<typeof DomainControlCharts>>();
const chartRefF2 = ref<InstanceType<typeof DomainControlCharts>>();
const chartRefR2 = ref<InstanceType<typeof DomainControlCharts>>();
const playStatus = ref<PlayStatus>("play");
const switching = ref("dTCS");
const isInited = ref(false);
// const idtest = ref("@@111@@");
const slide = ref(1);
const slide2 = ref(1);
const notifyData = reactive({} as Partial<DomianControl.DMCNotifyData>);

const DMCFrStatus = computed<FunctionStatus>(() => {
  if (notifyData.UIRx_DMCTgtMod_FA === 0) {
    return "disable"; // 未工作
  } else {
    if (notifyData.UIRx_DMCWrkSt_FA === 1) {
      return "active"; // 正常工作
    }
    return "enable"; // 允许工作
  }
});

const DMCRrStatus = computed<FunctionStatus>(() => {
  if (notifyData.UIRx_DMCTgtMod_RA === 0) {
    return "disable"; // 未工作
  } else {
    if (notifyData.UIRx_DMCWrkSt_RA === 1) {
      return "active"; // 正常工作
    }
    return "enable"; // 允许工作
  }
});
const FrontAxleDecTorqReq_Status = computed<FunctionStatus>(() => {
  if (notifyData.UIRx_XCU_FrontAxleDecTorqReq === 1) {
    return "active"; // 正常工作
  } else {
    return "disable";
  }
});
const RearAxleDecTorqReq_Status = computed<FunctionStatus>(() => {
  if (notifyData.UIRx_XCU_RearAxleDecTorqReq === 1) {
    return "active"; // 正常工作
  } else {
    return "disable";
  }
});

const arrowConfigs = computed(() => {
  return [
    {
      class: "arrow-group absolute top left",
      items: [
        {
          class: "arrow-top",
          value: notifyData.UIRx_MotTq_FA,
        },
        {
          class: "arrow-bottom",
          value: notifyData.UIRx_WhlBrkTqAct_FL_BCh1,
        },
      ],
    },
    {
      class: "arrow-group absolute top right",
      items: [
        {
          class: "arrow-top",
          value: notifyData.UIRx_MotTq_FA,
        },
        {
          class: "arrow-bottom",
          value: notifyData.UIRx_WhlBrkTqAct_FR_BCh1,
        },
      ],
    },
    {
      class: "arrow-group absolute bottom left",
      items: [
        {
          class: "arrow-top",
          value: notifyData.UIRx_MotTq_RA,
        },
        {
          class: "arrow-bottom",
          value: notifyData.UIRx_WhlBrkTqAct_RL_BCh1,
        },
      ],
    },
    {
      class: "arrow-group absolute bottom right",
      items: [
        {
          class: "arrow-top",
          value: notifyData.UIRx_MotTq_RA,
        },
        {
          class: "arrow-bottom",
          value: notifyData.UIRx_WhlBrkTqAct_RR_BCh1,
        },
      ],
    },
  ];
});

watch(
  () => seriesData.value,
  (newValue) => {
    const {
      UIRx_FLWhlSpd_BCh1_TCS,
      UIRx_FRWhlSpd_BCh1_TCS,
      UIRx_RLWhlSpd_BCh1_TCS,
      UIRx_RRWhlSpd_BCh1_TCS,
      UIRx_VehSpd_TCS,
      UIRx_FLWhlSpd_BCh1_dTCS,
      UIRx_FRWhlSpd_BCh1_dTCS,
      UIRx_RLWhlSpd_BCh1_dTCS,
      UIRx_RRWhlSpd_BCh1_dTCS,
      UIRx_VehSpd_dTCS,
    } = newValue;

    if (!isInited.value) return;
    if (switching.value === "TCS") {
      (optionsF.value as any)[1].data = UIRx_FLWhlSpd_BCh1_TCS?.concat();
      (optionsF.value as any)[2].data = UIRx_FRWhlSpd_BCh1_TCS?.concat();
      (optionsF.value as any)[0].data = UIRx_VehSpd_TCS?.concat();

      (optionsR.value as any)[1].data = UIRx_RLWhlSpd_BCh1_TCS?.concat();
      (optionsR.value as any)[2].data = UIRx_RRWhlSpd_BCh1_TCS?.concat();
      (optionsR.value as any)[0].data = UIRx_VehSpd_TCS?.concat();
    } else {
      (optionsF2.value as any)[1].data = UIRx_FLWhlSpd_BCh1_dTCS?.concat();
      (optionsF2.value as any)[2].data = UIRx_FRWhlSpd_BCh1_dTCS?.concat();
      (optionsF2.value as any)[0].data = UIRx_VehSpd_dTCS?.concat();

      (optionsR2.value as any)[1].data = UIRx_RLWhlSpd_BCh1_dTCS?.concat();
      (optionsR2.value as any)[2].data = UIRx_RRWhlSpd_BCh1_dTCS?.concat();
      (optionsR2.value as any)[0].data = UIRx_VehSpd_dTCS?.concat();
    }
  }
);

const handleDataZoom = (value: any) => {
  const { end, start } = value;
  // const start = 100 - end;
  const option = { dataZoom: [{ end, start: 0 }] };
  chartRefF.value?.echarts?.setOption(option);
  chartRefR.value?.echarts?.setOption(option);
  chartRefF2.value?.echarts?.setOption(option);
  chartRefR2.value?.echarts?.setOption(option);
};

const handleNotify = (data: DomianControl.DMCNotifyData) => {
  parseData(data);
  if (playStatus.value === "play") parseSeriesData(data);
};

const parseSeriesData = (data: DomianControl.DMCNotifyData) => {
  const res = [
    "UIRx_FLWhlSpd_BCh1_TCS",
    "UIRx_FRWhlSpd_BCh1_TCS",
    "UIRx_RLWhlSpd_BCh1_TCS",
    "UIRx_RRWhlSpd_BCh1_TCS",
    "UIRx_VehSpd_TCS",
    "UIRx_FLWhlSpd_BCh1_dTCS",
    "UIRx_FRWhlSpd_BCh1_dTCS",
    "UIRx_RLWhlSpd_BCh1_dTCS",
    "UIRx_RRWhlSpd_BCh1_dTCS",
    "UIRx_VehSpd_dTCS",
  ].reduce((per, key) => {
    const rawKey = key.replace(/(_dTCS)|(_TCS)/, "");
    let value = data[rawKey];
    // TODO: 待确认  其建说不用转
    // if (key.includes("WhlSpd")) {
    //   value = rpmToKph(value);
    // }
    const curList = seriesData.value[key] || [];
    if (curList.length >= decreasingSequence.length) curList.shift();
    curList.push(value);
    per[key] = curList;
    return per;
  }, {} as DomianControl.DMCSeriesData);
  seriesData.value = res;
};
const parseData = (value: DomianControl.DMCNotifyData) => {
  const newData = {
    UIRx_DMCTgtMod_FA: value.UIRx_DMCTgtMod_FA,
    UIRx_DMCTgtMod_RA: value.UIRx_DMCTgtMod_RA,
    UIRx_DMCWrkSt_FA: value.UIRx_DMCWrkSt_FA,
    UIRx_DMCWrkSt_RA: value.UIRx_DMCWrkSt_RA,
    UIRx_XCU_FrontAxleDecTorqReq: value.UIRx_XCU_FrontAxleDecTorqReq,
    UIRx_XCU_RearAxleDecTorqReq: value.UIRx_XCU_RearAxleDecTorqReq,
    UIRx_VehSpd: Math.round(value.UIRx_VehSpd),
    UIRx_ACULongdAcc: toFixed(value.UIRx_ACULongdAcc),
    UIRx_MotTq_FA: parseMotTq(value.UIRx_MotTq_FA),
    UIRx_MotTq_RA: parseMotTq(value.UIRx_MotTq_RA),
    UIRx_WhlBrkTqAct_FL_BCh1: parseNegative(value.UIRx_WhlBrkTqAct_FL_BCh1),
    UIRx_WhlBrkTqAct_FR_BCh1: parseNegative(value.UIRx_WhlBrkTqAct_FR_BCh1),
    UIRx_WhlBrkTqAct_RL_BCh1: parseNegative(value.UIRx_WhlBrkTqAct_RL_BCh1),
    UIRx_WhlBrkTqAct_RR_BCh1: parseNegative(value.UIRx_WhlBrkTqAct_RR_BCh1),
  } as any as DomianControl.DMCNotifyData;

  Object.keys(newData).forEach((key) => {
    notifyData[key] = newData[key];
  });
};

const handlePlayStatusChange = async () => {
  const value = playStatus.value === "play" ? "stop" : "play";
  console.log("[BOWEN_LOG] 🚀 ~~ handlePlayStatusChange ~~ value:", value);
  if (value === "play") {
    seriesData.value = getDefaultSeriesData();
    if (!isNotifyed.value) {
      $q.loading.show();
      await startNotifications().finally(() => $q.loading.hide());
    }
  }
  playStatus.value = value;
};
const parseOutputValue = (value: DomianControl.OutputValue) => {
  console.log("[BOWEN_LOG] 🚀 ~~ parseOutputValue ~~ value:", value);
  const { UITx_DMC_Ena } = value;
  switching.value = UITx_DMC_Ena === 0 ? "TCS" : "dTCS";
  isInited.value = true;
};

const handleSwitchChange = (value: any) => {
  switching.value = value;
  domainControlStore.writeOutputValue({
    UITx_DMC_Ena: value === "TCS" ? 0 : 1,
  });

  Object.keys(seriesData.value).map((key) => {
    if (key.includes("_" + value)) {
      seriesData.value[key] = [];
    }
  });
  // idtest.value += 1;

  // if (value === "TCS") {

  //   optionsF.value = getChartsDefaultOptions(0);
  //   optionsR.value = getChartsDefaultOptions(1);
  // } else {
  //   optionsF2.value = getChartsDefaultOptions(0);
  //   optionsR2.value = getChartsDefaultOptions(1);
  // }
};

const { startNotifications, stopNotifications, isNotifyed } = useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});

// onMounted(() => {
//   setInterval(() => {
//     handleNotify(generateMockDURNofifyData() as any);
//   }, 50);
// });
// onBeforeRouteLeave((to, from) => {
//   if (to.name === "TAA") {
//     domainControlStore.writeOutputValue({
//       UITx_DMC_Ena: 1, // dTCS
//     });
//   }
// });
</script>

<style scoped lang="scss">
.car-img {
  :deep(.q-img__content) > div {
    background-color: transparent;
    padding: 0;
  }
}
.q-img {
  overflow: unset;
}

/**
:deep(.q-toggle__inner--falsy) {
  .q-toggle__track {
    background: #4caf50;
  }
}
 */

.arrow-group {
  &.top {
    top: 10px;
  }
  &.left {
    left: -40px;
  }
  &.right {
    right: -40px;
  }
  &.bottom {
    bottom: 10px;
  }
  .arrow-bottom {
    margin-top: 10px;
    transform: rotate(180deg);
  }
}

:deep(.q-linear-progress__stripe) {
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.5) 25%,
    rgba(255, 255, 255, 0) 25%,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0.5) 75%,
    rgba(255, 255, 255, 0) 75%,
    rgba(255, 255, 255, 0)
  ) !important;
}

:deep(
    .q-linear-progress__model--indeterminate:before,
    .q-linear-progress__model--query:before
  ) {
  width: 50px;
  animation: q-linear-progress--indeterminate 0.8s linear infinite;
}
:deep(
    .q-linear-progress__model--indeterminate::after,
    .q-linear-progress__model--query:after
  ) {
  width: 0;
  animation: none;
  // animation: q-linear-progress--indeterminate 1s
  // cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite ;
  // animation-delay:1s ;
}

@keyframes q-linear-progress--indeterminate {
  0% {
    transform: translate3d(-35%, 0, 0) scale3d(0.35, 1, 1);
  }
  50% {
    transform: translate3d(150%, 0, 0) scale3d(0.9, 1, 1);
  }
  100% {
    transform: translate3d(300%, 0, 0) scale3d(0.9, 1, 1);
  }
}

@keyframes q-linear-progress--indeterminate-short {
  0% {
    transform: translate3d(-101%, 0, 0) scale3d(1, 1, 1);
  }
  60% {
    transform: translate3d(150%, 0, 0) scale3d(0.01, 1, 1);
  }
  100% {
    transform: translate3d(300%, 0, 0) scale3d(0.01, 1, 1);
  }
}
.glowing-effect {
  position: relative;
  top: -15px;
  width: 70%;
  height: 10px; /* 根据需求调整高度 */
  margin: 0 auto;
}

.glowing-effect::before {
  content: "";
  display: block;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    ellipse at center,
    rgb(255, 255, 255) 0%,
    rgba(255, 255, 255, 0) 70%
  ); /* 中间亮，边缘透明 */
  // box-shadow: 0 0 10px white, 0 0 20px white, 0 0 40px white;
  animation: glow 2s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
.btn-style {
  background: radial-gradient(
    circle at center,
    rgba(252, 251, 251, 0.8) 0%,
    /* 中心发光 */ rgb(176, 183, 193) 40%,
    /* 渐变过渡 */ rgb(142, 150, 161) 100% /* 边缘颜色 */
  ) !important;
}
.btn-active {
  background: radial-gradient(
    circle at center,
    rgba(247, 194, 145, 0.8) 0%,
    /* 中心发光 */ rgb(215, 153, 82) 40%,
    /* 渐变过渡 */ rgb(224, 101, 1) 100% /* 边缘颜色 */
  ) !important;
}
</style>
